import { Component } from '@angular/core';

@Component({
  selector: 'app-line-or-trend-chart-custom',
  template: '<app-chart-output></app-chart-output>'
})
export class LineOrTrendChartComponentCustom {

}
